"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/form/form.css");
require("@hotmart/cosmos/dist/form/input-checkbox.css");
require("@hotmart/cosmos/dist/form/input-custom.css");
require("@hotmart/cosmos/dist/form/input-default.css");
require("@hotmart/cosmos/dist/form/input-radio.css");
require("@hotmart/cosmos/dist/form/input-switch.css");
require("@hotmart/cosmos/dist/form/input-validate.css");
const Input = ({ className, error, ...props }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { className: (0, classnames_1.default)(className, 'hot-form__input', {
                    'is-invalid': error
                }), ...props }), error && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback _d-block", children: error })] }));
};
exports.default = Input;
